<template>

  <div>
    <InputSelect label="DRM Environment" v-model="env" :options="[
      { value: 'NONE', label: 'No DRM' },
      { value: 'DRMtoday', label: 'DRMtoday PRODUCTION' },
      { value: 'DRMtoday_STAGING', label: 'DRMtoday STAGING' },
      { value: 'DRMtoday_TEST', label: 'DRMtoday TEST' },
      { value: 'DRMtodayOnboard', label: 'DRMtoday Onboard' },
      { value: 'HeaderDrm', label: 'Header Based DRM' },
      { value: 'VerimatrixVCAS', label: 'Verimatrix VCAS Ultra' },
    ]"/>
    <div v-if="isDRMtoday">
      <FlexRow>
        <FlexItem><InputTextField label="Merchant" v-model="customData.merchant"/></FlexItem>
        <FlexItem><InputTextField label="User ID" v-model="customData.userId"/></FlexItem>
      </FlexRow>
      <FlexItem><InputTextField label="Session ID" v-model="customData.sessionId"/></FlexItem>
      <FlexItem><InputTextField label="Auth Token" v-model="customData.authToken" :null2undefined="true"/></FlexItem>
      <FlexRow>
        <FlexItem><InputTextField label="Asset ID" v-model="customData.assetId" :null2undefined="true"/></FlexItem>
        <FlexItem><InputTextField label="Variant ID" v-model="customData.variantId" :null2undefined="true"/></FlexItem>
      </FlexRow>
    </div>
    <div v-else-if="isDrmtodayOnboard">
      <FlexRow>
        <FlexItem><InputTextField label="Base URL" v-model="customData.baseUrl" help="The base URL to the DRM server."/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem><InputTextField label="Widevine Path/URL" v-model="customData.widevineUrl" help="The Widevine path or absolute URL. This defaults to 'widevine/'."/></FlexItem>
        <FlexItem><InputTextField label="Playready Path/URL" v-model="customData.playreadyUrl" help="The Playready path or absolute URL. This defaults to 'playready'."/></FlexItem>
        <FlexItem><InputTextField label="Fairplay Path/URL" v-model="customData.fairplayUrl" help="The fairplay path or absolute URL. This defaults to 'fairplay'."/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem><InputTextField label="Asset ID" v-model="customData.assetId" :null2undefined="true"/></FlexItem>
      </FlexRow>
    </div>
    <div v-else-if="isHeaderDrm">
      <FlexRow>
        <FlexItem><InputTextField label="Widevine License URL" v-model="customData.widevineLicenseUrl"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem><InputTextField label="PlayReady License URL" v-model="customData.playReadyLicenseUrl"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem><InputTextField label="FairPlay License URL" v-model="customData.fairPlayLicenseUrl"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem><InputTextField label="FairPlay Certificate URL" v-model="customData.fairPlayCertificateUrl"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem>
          <InputSelect label="FairPlay Content ID Strategy" v-model="customData.fairPlayContentIdStrategy" :options="[
            { value: 'full-skd', label: 'Full SKD' },
            { value: 'hostname', label: 'Hostname' }
          ]"/>
        </FlexItem>
      </FlexRow>

      <h3>Headers</h3>

      <p class="input-help">Add custom headers. This is a good place for specifying the authentication header for your custom DRM.</p>
      <div style="display: flex; align-items: center">
        <div style="flex: 0 1 auto;">
          <InputTextField label='Key' type="text" style="max-width: 100px; padding-right: 16px;" v-model="newHeaderKey"/>
        </div>
        <div style="flex: 1 1 auto; ">
          <InputTextField label='Value' type="text" style="max-width: 100px; padding-right: 16px;" v-model="newHeaderValue"/>
        </div>
        <div style="flex: 0 0 auto;">
          <button class="button" @click="addHeader()">
            <i class="icon">add_circle_outline</i>
          </button>
        </div>
      </div>

      <div style="display: flex; align-items: center" v-for="(value, key) in customData.headers" v-bind:key="key">
        <div style="flex-grow: 1">
          {{key}}: {{value}}
        </div>
        <div>
          <button class="button" style="margin-right: 1rem" @click="removeHeader(key)">
            <i class="icon">remove_circle_outline</i></button>
        </div>
      </div>
    </div>
    <div v-else-if="isVerimatrixVCAS">
      <FlexRow>
        <FlexItem><InputTextField label="Device ID" v-model="customData.deviceId" help="The device's Verimatrix unique identifier (VUID)"/></FlexItem>
        <FlexItem><InputTextField label="Authenticator (optional)" v-model="customData.authenticator" help="Optional third-party authentication"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem>
          <InputSelect label="Method for passing Device ID and Authenticator to the license server." v-model="customData.licenseRequestVuidLocation" :options="[
            { value: 'query-string', label: 'Query string' },
            { value: 'http-header', label: 'HTTP Header' }
          ]"/>
        </FlexItem>
      </FlexRow>
      <FlexRow v-if="customData.licenseRequestVuidLocation === 'http-header'">
        <FlexItem><InputTextField label="Device ID custom HTTP header" v-model="customData.httpHeaderNames.DeviceId" help="The name of the HTTP header to use for passing Device ID"/></FlexItem>
        <FlexItem><InputTextField label="Authenticator custom HTTP header" v-model="customData.httpHeaderNames.Authenticator" help="The name of the HTTP header to use for passing Authenticator"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem><InputTextField label="Widevine License URL" v-model="customData.widevineLicenseUrl"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem><InputTextField label="PlayReady License URL" v-model="customData.playReadyLicenseUrl"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem><InputTextField label="FairPlay License URL" v-model="customData.fairPlayLicenseUrl"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem><InputTextField label="FairPlay Certificate URL" v-model="customData.fairPlayCertificateUrl"/></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem>
          <InputSelect label="FairPlay assetId acquisition strategy" v-model="customData.fairPlayAssetIdStrategy" :options="[
            { value: 'keyid', label: 'Key ID' },
            { value: 'contentid-siteid', label: 'Content ID + Site ID' }
          ]"/>
        </FlexItem>
      </FlexRow>
      <FlexRow v-if="customData.fairPlayAssetIdStrategy === 'contentid-siteid'">
        <FlexItem><InputTextField label="Site ID" v-model="customData.siteId"/></FlexItem>
      </FlexRow>
    </div>
    <div v-if="!noDrmEnvironment">
      <FlexRow>
        <FlexItem>
          <InputTextField label="Widevine Video Robustness"
                          :text2array="true"
                          v-model="customData.widevineVideoRobustness"
                          help="Enter a comma separated list. Possible values are:
                           'HW_SECURE_ALL', 'HW_SECURE_DECODE', 'HW_SECURE_CRYPTO', 'SW_SECURE_DECODE', 'SW_SECURE_CRYPTO'. Use 'undefined' to explicitly declare that no robustness values should be set. By default, we pass all available levels from highest to lowest security level."/>
        </FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem>
          <InputTextField label="Widevine Audio Robustness"
                          :text2array="true"
                          v-model="customData.widevineAudioRobustness"
                          help="Enter a comma separated list. Possible values are:
                           'HW_SECURE_ALL', 'HW_SECURE_DECODE', 'HW_SECURE_CRYPTO', 'SW_SECURE_DECODE', 'SW_SECURE_CRYPTO'. Use 'undefined' to explicitly declare that no robustness values should be set. By default, we pass all available levels from highest to lowest security level."/>
        </FlexItem>
      </FlexRow>
      <FlexRow style="margin: 20px 0">
        <FlexItem base="30%">
          <InputCheckbox
            label="Widevine Distinctive Identifier Required"
            v-model="customData.widevineDistinctiveIdentifierRequired"
            help="Indicates whether a persistent distinctive identifier is required."
          />
        </FlexItem>
        <FlexItem base="30%">
          <InputCheckbox
            label="Widevine Persistent State Required"
            v-model="customData.widevinePersistentStateRequired"
            help="Indicates whether the ability to persist state is required."
          />
        </FlexItem>
        <FlexItem base="30%"></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem base="33%">
          <InputSelect
            label="Widevine Version"
            v-model="widevineVersion"
            help="Try experimental Widevine key systems."
            :options="[
              { value: '', label: 'com.widevine.alpha' },
              { value: 'com.widevine.alpha.experiment', label: 'com.widevine.alpha.experiment' },
              { value: 'com.widevine.alpha.experiment2', label: 'com.widevine.alpha.experiment2' },
            ]"
          />
        </FlexItem>
        <FlexItem base="66%"></FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem>
          <InputTextField label="PlayReady Video Robustness"
                          :text2array="true"
                          v-model="customData.playReadyVideoRobustness"
                          help="Enter a comma separated list. Possible values are:
                           '3000', '2000', or '150'. Use 'undefined' to explicitly declare that no robustness values should be set. By default, we pass all available levels from highest to lowest security level."/>

        </FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem>
          <InputTextField label="PlayReady Audio Robustness"
                          :text2array="true"
                          v-model="customData.playReadyAudioRobustness"
                          help="Enter a comma separated list. Possible values are:
                           '2000', or '150'. Use 'undefined' to explicitly declare that no robustness values should be set. By default, we pass all available levels from highest to lowest security level."/>
        </FlexItem>
      </FlexRow>
    </div>
    <div>
      <InputSelect label="EME API" v-model="emeApi" :options="[
        { value: '', label: 'Auto' },
        { value: 'STANDARD', label: 'Standard EME implementation' },
        { value: 'APPLE', label: 'Apple legacy EME implementation' },
        { value: 'WEBKIT', label: 'Webkit-prefixed EME implementation v0.1b' },
      ]" help="Use this to select specific EME implementation on Safari."/>
    </div>
  </div>

</template>

<script>
import InputSelect from '../../forms/InputSelect';
import FlexRow from '../../layout/FlexRow';
import FlexItem from '../../layout/FlexItem';
import InputTextField from '../../forms/InputTextField';
import InputCheckbox from '../../forms/InputCheckbox';

const EMPTY_CUSTOM_DATA = {
  userId: '',
  sessionId: '',
  merchant: '',
  authToken: undefined,
  assetId: undefined,
  variantId: undefined,
  baseUrl: undefined,
  widevineUrl: undefined,
  playreadyUrl: undefined,
  fairplayUrl: undefined,
  widevineLicenseUrl: undefined,
  widevineVideoRobustness: undefined,
  widevineAudioRobustness: undefined,
  widevineDistinctiveIdentifierRequired: undefined,
  widevinePersistentStateRequired: undefined,
  playReadyLicenseUrl: undefined,
  playReadyVideoRobustness: undefined,
  playReadyAudioRobustness: undefined,
  fairPlayLicenseUrl: undefined,
  fairPlayCertificateUrl: undefined,
  fairPlayContentIdStrategy: 'full-skd',
  headers: {},
  // Verimatrix VCAS specific fields
  deviceId: '',
  authenticator: undefined,
  licenseRequestVuidLocation: undefined,
  httpHeaderNames: { DeviceId: 'DeviceId', Authenticator: 'Authenticator' },
  fairPlaySiteId: undefined,
  fairPlayAssetIdStrategy: undefined,
  widevineVersion: ''
};

export default {
  name: 'PlayerConfigDrmConfig',
  components: {
    InputCheckbox,
    InputTextField,
    FlexItem,
    FlexRow,
    InputSelect,
  },
  props: ['value'],
  data: function () {
    return {
      customData: null,
      env: 'NONE',
      newHeaderKey: '',
      newHeaderValue: '',
      emeApi: '',
      widevineVersion: ''
    };
  },
  computed: {
    noDrmEnvironment: function () {
      return this.env === 'NONE';
    },
    isDRMtoday: function () {
      return this.env.startsWith('DRMtoday') && !this.isDrmtodayOnboard;
    },
    isDrmtodayOnboard: function () {
      return this.env === 'DRMtodayOnboard';
    },
    isHeaderDrm: function () {
      return this.env === 'HeaderDrm';
    },
    isVerimatrixVCAS: function () {
      return this.env === 'VerimatrixVCAS';
    }
  },
  methods: {
    removeHeader (key) {
      if (key) {
        delete this.customData.headers[key];
        this.customData.headers = Object.assign({}, this.customData.headers);
      }
    },
    addHeader () {
      if (this.newHeaderKey && this.newHeaderValue) {
        this.customData.headers[this.newHeaderKey] = this.newHeaderValue;
        this.newHeaderKey = '';
        this.newHeaderValue = '';
      }
    },
    setDrmConfig () {
      if (this.value) {
        if (this.env === 'NONE') {
          this.value.drm = null;
        } else {
          this.value.drm = {
            env: this.env,
            customData: this.customData,
            emeApi: this.emeApi,
            widevineVersion: this.widevineVersion
          };
        }
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        if (!newVal || !newVal.drm || !newVal.drm.env) {
          // the asset has no drm data
          this.env = 'NONE';
          this.customData = Object.assign({}, EMPTY_CUSTOM_DATA);
        } else if (newVal && newVal.drm) {
          this.env = newVal.drm.env;
          this.customData = newVal.drm.customData;
          this.emeApi = newVal.drm.emeApi;
          this.widevineVersion = newVal.drm.widevineVersion;
        }
      }
    },
    env: function (newVal) {
      this.setDrmConfig();
    },
    emeApi: function (newVal) {
      this.setDrmConfig();
    },
    widevineVersion: function (newVal) {
      this.setDrmConfig();
    }
  }
};
</script>

<style scoped>

</style>
